export default function StandalonePaymentHandoff() {
  return (
    <main className="main-container" style={{ padding: 24, textAlign: 'center' }}>
      <div className="box" style={{ maxWidth: 400, margin: '40px auto' }}>
        <h2 style={{ color: 'var(--primary)', marginBottom: 12 }}>Cửa sổ thanh toán</h2>
        <p style={{ lineHeight: 1.6, marginBottom: 16 }}>
          Đã mở cửa sổ thanh toán. Vui lòng hoàn tất giao dịch ở cửa sổ đó — sau khi xong, cửa sổ sẽ tự đóng.
        </p>
        <p style={{ fontSize: 14, color: 'var(--grey)' }}>
          Bạn có thể đóng tab này nếu không thấy cửa sổ thanh toán (kiểm tra trình chặn popup).
        </p>
      </div>
    </main>
  );
}
